import { Box, Typography } from "@material-ui/core";
import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Row, Col } from "reactstrap";

const COLORSIMPOSTO = ["#9BB2DB", "#79D1A1", "#F5C2C2", "#F9D979", "#7E7BF9"];
const COLORSCMV = ["#9BB2DB", "#79D1A1", "#F9D979", "#7E7BF9"];
const COLORSDESPESA = ["#9BB2DB", "#79D1A1", "#F5C2C2", "#F9D979"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default function PieChartRecharts({ totalizadoresPieChart }) {

  const dataImposto = [
    { name: "PIS/COFINS", value: totalizadoresPieChart.totalImpostoPieChart.totalImpostoPISCOFINS },
    { name: "ICMS", value: totalizadoresPieChart.totalImpostoPieChart.totalImpostoICMS },
    { name: "ISS", value: totalizadoresPieChart.totalImpostoPieChart.totalImpostoGastos },
    { name: "SIMPLES", value: totalizadoresPieChart.totalImpostoPieChart.totalImpostoSimplesNacional },
    { name: "ADICIONAIS", value: totalizadoresPieChart.totalImpostoPieChart.totalImpostoReceitasAdicionais },
  ];

  const dataCmv = [
    { name: "APARELHO", value: totalizadoresPieChart.totalCmvPieChart.totalCmvAparelho },
    { name: "CHIP", value: totalizadoresPieChart.totalCmvPieChart.totalCmvChip },
    { name: "ACESSÓRIO", value: totalizadoresPieChart.totalCmvPieChart.totalCmvAcessorio },
    { name: "ADICIONAIS", value: totalizadoresPieChart.totalCmvPieChart.totalCmvReceitasAdicionais },
  ];

  const dataDespesa = [
    { name: "ESTRUTURAL", value: totalizadoresPieChart.totalDespesaPieChart.totalEstrutural },
    { name: "OCUPAÇÃO", value: totalizadoresPieChart.totalDespesaPieChart.totalOcupacao },
    { name: "CARTÃO", value: totalizadoresPieChart.totalDespesaPieChart.totalCartao },
    { name: "PESSOAL", value: totalizadoresPieChart.totalDespesaPieChart.totalPessoal }
  ];

  return (
    <div className="content" style={{ display: "flex", textAlign: "center" }}>
      <div style={{ width: "30%", height: 350 }}>
        <div style={{ width: "100%", textAlign: "center" }}><labe><strong>IMPOSTOS</strong></labe></div>
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={dataImposto}
                labelLine={false}
                label={renderCustomizedLabel}
                fill="#8884d8"
                dataKey="value"
              >
                {dataImposto.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORSIMPOSTO[index % COLORSIMPOSTO.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div style={{ width: "100%" }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Row>
              {COLORSIMPOSTO.map((color, i) => (
                <Col key={color} style={{ textAlign: "center" }}>
                  <Box sx={{ width: 8, height: 8, background: color }}></Box>
                  <Typography variant="body2" style={{ fontSize: "10px" }} sx={{ opacity: 0.7 }}>{dataImposto[i]?.name}</Typography>
                </Col>
              ))}
            </Row>
          </Box>
        </div>
      </div>
      <div style={{ width: "1px", backgroundColor: "#ccc", height: 350, margin: '0 10px' }}></div>
      <div style={{ width: "30%", height: 350 }}>
        <div style={{ width: "100%", textAlign: "center" }}><labe><strong>CMV</strong></labe></div>
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={dataCmv}
                labelLine={false}
                label={renderCustomizedLabel}
                fill="#8884d8"
                dataKey="value"
              >
                {dataCmv.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORSCMV[index % COLORSCMV.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div style={{ width: "100%" }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Row>
              {COLORSCMV.map((color, i) => (
                <Col key={color} style={{ textAlign: "center" }}>
                  <Box sx={{ width: 8, height: 8, background: color }}></Box>
                  <Typography variant="body2" style={{ fontSize: "10px" }} sx={{ opacity: 0.7 }}>{dataCmv[i]?.name}</Typography>
                </Col>
              ))}
            </Row>
          </Box>
        </div>
      </div>
      <div style={{ width: "1px", backgroundColor: "#ccc", height: 350, margin: '0 10px' }}></div>
      <div style={{ width: "30%", height: 350 }}>
        <div style={{ width: "100%", textAlign: "center" }}><labe><strong>DESPESAS</strong></labe></div>
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={dataDespesa}
                labelLine={false}
                label={renderCustomizedLabel}
                fill="#8884d8"
                dataKey="value"
              >
                {dataDespesa.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORSDESPESA[index % COLORSDESPESA.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div style={{ width: "100%" }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Row>
              {COLORSDESPESA.map((color, i) => (
                <Col key={color} style={{ textAlign: "center" }}>
                  <Box sx={{ width: 8, height: 8, background: color }}></Box>
                  <Typography variant="body2" style={{ fontSize: "10px" }} sx={{ opacity: 0.7 }}>{dataDespesa[i]?.name}</Typography>
                </Col>
              ))}
            </Row>
          </Box>
        </div>
      </div>
    </div>
  );
}
